/* unplugin-vue-components disabled */import script from "./ExternalPersonTag.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalPersonTag.vue?vue&type=script&setup=true&lang=js"

import "./ExternalPersonTag.vue?vue&type=style&index=0&id=c73556b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c73556b6"]])

export default __exports__